import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

const StyledLabelOffBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isLiftStationMobile',
})<{ isLiftStationMobile?: boolean }>(({ theme, isLiftStationMobile }) => ({
  display: 'inline-block',
  background: theme.palette.grey[300],
  padding: isLiftStationMobile ? '2px 6px' : '2px 8px',
  borderRadius: '6px',
}));

const StyledLabelText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isLiftStationMobile',
})<{ isLiftStationMobile?: boolean }>(({ theme, isLiftStationMobile }) => ({
  color: theme.palette.grey[600],
  fontSize: isLiftStationMobile ? '10px' : '12px',
  fontWeight: '700',
}));
export { StyledLabelOffBox, StyledLabelText };
